// extracted by mini-css-extract-plugin
export default {"loader_container":"Avatar_loader_container__3muGs","spinner":"Avatar_spinner__6FUcJ","spin":"Avatar_spin__e4ZL0"};